import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FaultData } from '../problem-list.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MetricsService } from 'src/app/services/metrics.service';
import { forkJoin, Observable } from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf, DatePipe } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

export interface BulkUpdateData {
  objectType: string;
  faults: FaultData[];
}

@Component({
    selector: 'app-bulk-update-dialog',
    templateUrl: './bulk-update-dialog.component.html',
    styleUrl: './bulk-update-dialog.component.scss',
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgIf, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDivider, MatFormField, MatLabel, MatInput, MatProgressSpinner, MatDialogActions, MatButton, DatePipe]
})
export class BulkUpdateDialog {
  protected displayedColumns: string[] = ['ShiftDate','Shift', 'Hour','Downtime','FaultMessage']; // List of columns

  protected faultListNoLostUnits: FaultData[];
  protected fgNote:FormGroup;
  protected isSaving:boolean = false;

  constructor(
    public dialogRef: MatDialogRef<BulkUpdateDialog>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public inData: BulkUpdateData,
    private fb: FormBuilder,
    private svcMetrics:MetricsService
  ) {
    this.faultListNoLostUnits = inData.faults;

    this.fgNote = this.fb.group({
      note: ['']
    })

  }

  formatDuration(seconds:number) {
    return new Date(seconds * 1000).toISOString().slice(11, 19);
  }

  update(): void {
    this.isSaving = true;
    let note:string =  this.fgNote.get("note").value;

    if (!note || note == '') {
      note = 'Bulk Updated No Lost Unit Faults';
    }
    this.fgNote.disable();
    
    console.log("note", note);
    console.log("fgNote", this.fgNote);

    let updateObs: Observable<any>[] = [];
    
    this.faultListNoLostUnits.forEach(
      fault => {
        updateObs.push(
          this.svcMetrics.updateFault(
            '',
            'Reviewed - No Lost Units',
            '',
            '',
            note,
            fault.ID,
            fault.FaultValue,
            fault.FaultMessage,
            fault.Hour,
            fault.shift,
            fault.shiftDate,
            fault.objectid,
            fault.site,
            fault.Problem,
            fault.Problem_Level2,
            fault.Problem_Level3,
            fault.Notes,
            fault.Team,
            fault.Source
          )
        );
      });
    
    if (updateObs.length > 0) {
      forkJoin(updateObs).subscribe(
        result => {
          console.log("Updates Complete", result);

          this.close(true);
          this.isSaving = false;
        }
      )
    } else {
      this.close(false);
      this.isSaving = false;
    }
  }

  close(updates:boolean = false): void {
    this.dialogRef.close({ updates: updates});
  }
}